
export default class Pregunta {
    constructor(
        public id: number = 0,
        public parentId: number = 0,
        public text: string = '',
        public type: string = '',
        public responseValue: string = '',
        public help: string = '',
        public masc: string = '',
        public validate: string = '',
        public order: number = 0,
        public placeHolder: string = "PlaceHolder",
        public obligatoria : boolean = true,
        public required : string = "N",
        public dataType: string='',
        public children: Pregunta[] = [],
        public isBeneficiarioGroup : boolean = false,
        public idReiterativo?:number,
        public idNew?:number,
        public editable?:boolean,
        public desplegarCol : string= "2",
        public indRequerido? : string,
        public indRequiereCarga ?: string,
        public codUbigeo?:string,
        public indValidaCedula?:string,
        public indValidaEmail?:string,
        public indValidaTelefono?:string,
        public indValidaFecha?:string,
        public maxLongitud?:number,
        public minLongitud?:number,
        public indValidar?: string,
        public separador?:string
    ) {
        
    }
}